import React, { Fragment, useContext } from 'react';
import { LoginContext } from '../../hooks/context/LoginContext';
import { NavLink } from 'react-router-dom';
import ShowFirmas from '../formulario/ShowFirmas';
import GoToRunCicCfg from '../formulario/GoToRunCicCfg';
import InformesBtn from '../formulario/informes/informesBtn/InformesBtn';
import { getDecodedCookie, getPantDocFromNivel } from '../../helpers/helperApp';

function Section(props){

    const { apiKey, confApp, logo, appCryptCom } = useContext(LoginContext);
    
    const {tituloenhtml, titulo, icono, col, clases, idPrin, idHijo, wiki, borderHeader, recurrencia, getFirmas, traduction, formulario, editCabEdirap, idDocGoToRunCicCfg, informes} = props;    

    return(
            <section className={clases ? `${clases} content col-md-${col} connectedSortable ui-sortable` : ` content col-md-${col} connectedSortable ui-sortable`} style={{paddingLeft : "0px", paddingRight : "0px" }} >
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                { titulo !== '' && titulo != undefined
                                ?
                                    <div className="card-header">
                                        <h3 className="card-title mr-2"                                    
                                            style={ 
                                                borderHeader != null && borderHeader != "" 
                                                ? 
                                                    {borderBottom: "3px solid "+borderHeader, paddingBottom: "5px"  } 
                                                : 
                                                    {} 
                                                } 
                                        >
                                            {
                                                tituloenhtml == undefined || tituloenhtml == false
                                                ?
                                                    <i className={icono} style={ 
                                                        borderHeader != null && borderHeader != "" 
                                                        ? 
                                                            {color: borderHeader, marginRight: 5  } 
                                                        : 
                                                            {marginRight: 5  }  
                                                        } >                                                
                                                    </i>
                                                :
                                                    null
                                            }                                            
                                            {
                                                !titulo.includes("undefined") && tituloenhtml == true
                                                ?                                                                                                           
                                                    <div dangerouslySetInnerHTML=
                                                    // {{ __html: `<i class='${icono}' style='color: ${borderHeader}; margin-right: 5px; padding-top: 4px'></i> ${titulo}` }}
                                                    {{ __html: `${titulo}` }}
                                                    >
                                                    </div>                                                     
                                                :
                                                    null
                                            } 
                                            {
                                                !titulo.includes("undefined") && (tituloenhtml == undefined || tituloenhtml == false)
                                                ? 
                                                    titulo 
                                                :
                                                    null
                                            }
                                        </h3>                                      
                                        {
                                            wiki
                                            ?
                                                <a href={wiki} target="_blank" style={{color: "inherit"}} className="ml-1"><i className="fal fa-question-circle"></i></a>
                                            :   
                                                null
                                        }
                                        {
                                            idPrin != "" && idHijo != "" && idPrin != undefined && idHijo != undefined
                                            ?
                                            <small className="text-muted ml-1">{"- "}{idPrin}{"/"}{idHijo}</small>
                                            :
                                                (idPrin > 0 && idHijo == "") || (idPrin > 0 && idHijo == undefined) 
                                                ?
                                                <small className="text-muted ml-1">{"- "}{idPrin}</small>
                                                :
                                                null
                                        }
                                        {
                                            editCabEdirap && idPrin > 0
                                            ?
                                                <Fragment>
                                                    {/* <a 
                                                        className="btn btn-outline-primary ml-1 mr-1"                                                   
                                                        href={getPantDocFromNivel(getDecodedCookie('nivel'))+"/"+idPrin} 
                                                    >
                                                        <i className="fal fa-eye"></i>  
                                                    </a> */}
                                                    <NavLink to={getPantDocFromNivel(getDecodedCookie('nivel'))+"/"+idPrin} className="btn btn-outline-primary ml-1 mr-1" >
                                                        <i className="fal fa-eye" />                                                        
                                                    </NavLink>
                                                    <button 
                                                        type="button" 
                                                        onClick={ e => editCabEdirap(e) } 
                                                        className="btn btn-outline-primary mr-1" 
                                                        disabled={ false } 
                                                    >
                                                        <i className="fal fa-edit"></i>
                                                    </button> 
                                                </Fragment>
                                            :
                                                null
                                        }
                                        {
                                            // informes != undefined && idPrin > 0
                                            informes != undefined
                                            ?
                                                <InformesBtn
                                                    select =     { informes.select }
                                                    formulario = { {id: idPrin} }
                                                    getRegistro = { informes.getregistro }
                                                    loadReg =    { false }
                                                    estadoForm=  { "" } 
                                                    traduction=  { confApp.config.trad.components }
                                                    btnGenerar= { informes.btngenerar.title }
                                                    logoContext={logo}
                                                    apiKeyContext={apiKey}
                                                    confAppContext={confApp}
                                                    appCryptComContext={appCryptCom}
                                                    buttonOutLine={true}
                                                />
                                            :
                                                null
                                        }
                                        {
                                            idDocGoToRunCicCfg && idPrin > 0
                                            ?                                                
                                                <GoToRunCicCfg                                                    
                                                    idDoc={idDocGoToRunCicCfg}                                                    
                                                />
                                            :
                                                null
                                        }
                                        {
                                            recurrencia 
                                            ? 
                                                <span className='alert-primary pl-3 pr-3 pt-2 pb-2 float-right' style={{borderRadius: "5px"}} >
                                                        {recurrencia}
                                                </span>
                                            :
                                                null
                                        }
                                        {
                                            idPrin > 0
                                            ?
                                                <ShowFirmas
                                                idPrin={idPrin}
                                                getFirmas={getFirmas}
                                                traduction={traduction}
                                                />                                            
                                            :                                             
                                                null
                                        }
                                        {
                                            idPrin > 0 && formulario && formulario.notas && typeof formulario.notas === 'string' && formulario.notas.toLowerCase().includes('**OFFLINE**'.toLowerCase())
                                            ?
                                                <span className='alert-dark pl-3 pr-3 pt-2 pb-2 mr-1 float-right' style={{borderRadius: "5px"}} >
                                                        <i className='fal fa-tablet-alt'></i>
                                                </span>
                                            :
                                                null
                                        }
                                    </div>
                                :
                                null
                                }
                                <div className="card-body pad table-responsive">
                                    {props.children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </section>
    )
}

export default Section;